import { gql } from '@apollo/client';

export const AnalyzeStandardImportMutationName = 'AnalyzeStandardImport';

export const ANALYZE_STANDARD_IMPORT_MUTATION = gql`
  mutation ${AnalyzeStandardImportMutationName}(
    $file: Upload!
    $allowAi: Boolean! = false
  ) {
    analyzeStandardImport(file: $file, allowAi: $allowAi) {
      standardImport {
        id
        importMode
        status
      }
    }
  }
`;
